// Player-page text helpers, ported from public/assets/player.js.
import type { GameDetail } from "./types";

const MONTHS = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

export function isMultiplayer(game: Pick<GameDetail, "multiplayer" | "family">): boolean {
  return game?.multiplayer === true || game?.family === "yog-multiplayer";
}

export function isQueuedForPort(game: GameDetail): boolean {
  return game.catalog === "java-port-queue" || String((game as any).labStatus || "").startsWith("needs");
}

function heldRuntimeName(game: GameDetail): string {
  if (game.type === "flash" || game.player?.type === "flash") return "Flash";
  if (game.type === "remake" || game.player?.type === "remake") return "Remake";
  if (game.type === "port" || game.player?.type === "js-port") return "Port";
  return "Java";
}

export function runtimeText(game: GameDetail): string {
  if (isQueuedForPort(game)) return `${heldRuntimeName(game)} · held for recovery`;
  if (game.family === "yog-multiplayer") return "Java · online multiplayer";
  if (game.playability === "experimental") return "Java · CheerpJ lab";
  if (game.type === "flash") return "Flash · runs in Ruffle";
  if (game.type === "remake") return "Remake · faithful HTML5";
  if (game.type === "original-applet") return "Original · runs in CheerpJ";
  if (game.type === "port") return "Java · restored as HTML5";
  return "Java · runs in CheerpJ";
}

export function sideTag(game: { type?: string | null; playability?: string | null; catalog?: string | null }): string {
  if (game.catalog === "java-port-queue") return "Held";
  if (game.playability === "experimental") return "Lab";
  if (game.type === "flash") return "Flash";
  if (game.type === "remake") return "Remake";
  if (game.type === "original-applet") return "Original";
  if (game.type === "port") return "Port";
  return "Java";
}

export function figMeta(game: GameDetail): string {
  const parts: string[] = [];
  if (game.category) parts.push(game.category);
  if (game.sourceSnapshot) {
    const snap = String(game.sourceSnapshot);
    const month = MONTHS[Number(snap.slice(4, 6)) - 1];
    parts.push(`snapshot ${month ? `${month} ` : ""}${snap.slice(0, 4)}`);
  }
  const plays = Number(game.playCount);
  if (Number.isFinite(plays) && plays > 0) parts.push(`${plays.toLocaleString("en-US")} plays on record`);
  return parts.join(" · ");
}

export function waybackUrl(game: GameDetail): { href: string; year: string } | null {
  if (!game.sourceSnapshot || !game.sourcePageUrl) return null;
  const snap = String(game.sourceSnapshot);
  return { href: `https://web.archive.org/web/${snap}/${game.sourcePageUrl}`, year: snap.slice(0, 4) };
}
